// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License. See License.txt in the project root for license information.
/**
 * The default language in the request header.
 *
 * @const
 * @type {string}
 */
export var DEFAULT_LANGUAGE = "en-us";
/**
 * The ms-rest-azure version.
 * @const
 * @type {string}
 */
export var msRestAzureVersion = "2.1.0";